import React from 'react';

interface NumberInputProps {
    label: string;
    subLabel?: string;
    name: string;
    placeholder?: string;
    error?: boolean;
    required?: boolean;
}

const NumberInput: React.FC<NumberInputProps> = ({
                                                     label,
                                                     subLabel,
                                                     name,
                                                     placeholder,
                                                     error = false,
                                                     required = false
                                                 }) => {

    const handleKeyDown = (e: any) => {
        // Prevent up/down arrow keys from changing the value
        if (e.key === "ArrowUp" || e.key === "ArrowDown") {
            e.preventDefault();
        }
    };

    const handleWheel = (e: React.WheelEvent<HTMLInputElement>) => {
        // Prevent mouse wheel from changing the value when input is focused
        e.currentTarget.blur();
        e.preventDefault();
    };


    return (
        <div className="form-field">
            {label && <label className={required ? 'required-field' : ''}>{label}</label>}
            {subLabel && <div className="sub-label">{subLabel}</div>}
            <input
                type="number"
                name={name}
                className={`text-input ${error ? 'error-border' : ''}`}
                placeholder={placeholder}
                onKeyDown={handleKeyDown}
                onWheel={handleWheel}
            />
        </div>
    );
};

export default NumberInput;